// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex_EKocy {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-rowS_mEU8b {
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-rowM_dkX22 {
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-rowSpaceBetween_jHv0W {
  display: flex;
  justify-content: space-between;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMEnd_ptXm_ {
  display: flex;
  justify-content: flex-end;
}
.flex_EKocy.flex-col_bdUO1 {
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colS_qus8Z {
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB {
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colL_FglUl {
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colXL_aDtre {
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colXXL_Q1MZk {
  display: flex;
  flex-direction: column;
}

.flex_EKocy.flex-col_bdUO1.flex-toolbarVertical_B0FKm {
  justify-items: stretch;
  align-items: flex-start;
}


.flex_EKocy.flex-col_bdUO1.flex-colXXL_Q1MZk > *+* {
  margin: 40px 0 0 0;
}
.flex_EKocy.flex-col_bdUO1.flex-colXL_aDtre > *+* {
  margin: var( --size-padXXLarge ) 0 0 0;
}
.flex_EKocy.flex-col_bdUO1.flex-colL_FglUl > *+* {
  margin: var( --size-padLarge ) 0 0 0;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB > *+* {
  margin: var( --size-padMedium ) 0 0 0;
}
.flex_EKocy.flex-col_bdUO1.flex-colS_qus8Z > *+* {
  margin: var( --size-padSmall ) 0 0 0;
}
.flex_EKocy.flex-rowM_dkX22 > *+* {
  margin: 0 0 0 var( --size-padMedium );
}
.flex_EKocy.flex-rowS_mEU8b > *+* {
  margin: 0 0 0 var( --size-small );
}`, "",{"version":3,"sources":["webpack://./src/theme/Flex.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".flex {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-rowS {\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-rowM {\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-rowSpaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n.flex.flex-rowM.flex-rowMEnd {\n  display: flex;\n  justify-content: flex-end;\n}\n.flex.flex-col {\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colS {\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colM {\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colL {\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colXL {\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colXXL {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex.flex-col.flex-toolbarVertical {\n  justify-items: stretch;\n  align-items: flex-start;\n}\n\n\n.flex.flex-col.flex-colXXL > *+* {\n  margin: 40px 0 0 0;\n}\n.flex.flex-col.flex-colXL > *+* {\n  margin: var( --size-padXXLarge ) 0 0 0;\n}\n.flex.flex-col.flex-colL > *+* {\n  margin: var( --size-padLarge ) 0 0 0;\n}\n.flex.flex-col.flex-colM > *+* {\n  margin: var( --size-padMedium ) 0 0 0;\n}\n.flex.flex-col.flex-colS > *+* {\n  margin: var( --size-padSmall ) 0 0 0;\n}\n.flex.flex-rowM > *+* {\n  margin: 0 0 0 var( --size-padMedium );\n}\n.flex.flex-rowS > *+* {\n  margin: 0 0 0 var( --size-small );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `flex_EKocy`,
	"flex-rowS": `flex-rowS_mEU8b`,
	"flex-rowM": `flex-rowM_dkX22`,
	"flex-rowSpaceBetween": `flex-rowSpaceBetween_jHv0W`,
	"flex-rowMEnd": `flex-rowMEnd_ptXm_`,
	"flex-col": `flex-col_bdUO1`,
	"flex-colS": `flex-colS_qus8Z`,
	"flex-colM": `flex-colM_nHyiB`,
	"flex-colL": `flex-colL_FglUl`,
	"flex-colXL": `flex-colXL_aDtre`,
	"flex-colXXL": `flex-colXXL_Q1MZk`,
	"flex-toolbarVertical": `flex-toolbarVertical_B0FKm`
};
export default ___CSS_LOADER_EXPORT___;
